export default __webpack_public_path__ + "389f78d1647b6f56594458f91f198b37.png";